import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2346632263 from "../../../../../packages/component/src/components/dropdown/demo/demo1.js?loadDemo";
import legacyImportDemo_3551833572 from "../../../../../packages/component/src/components/dropdown/demo/demo2.js?loadDemo";
import legacyImportDemo_4258182917 from "../../../../../packages/component/src/components/dropdown/demo/demo3.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2346632263,
  legacyImportDemo_3551833572,
  legacyImportDemo_4258182917,
  React
};